<component-modal [showFooter]="false" [showHeader]="false">
  <ng-container body>
    <div class="d-flex flex-column align-items-center gap-4">
      <!-- Icon -->
      <div class="logo-container">
        <svg-icon src="assets/logo.svg" />
      </div>

      <!-- Content -->
      <div class="d-flex flex-column align-items-center gap-2">
        <h4 class="fw-bold">Welcome to 0Docs!</h4>

        @if (isInviteRegistration()) {
          <div class="text-center">
            <p class="m-0">
              You've been successfully added to
              <span class="fw-bold m-0">{{ organizationName() }}</span>
              organization with the <span class="fw-bold m-0">{{ planName() }}</span> plan
            </p>
          </div>
        } @else {
          <p class="text-center m-0">You have full access {{ expirationMessage() }} - no signup required. Enjoy the flow</p>
        }
      </div>

      <button type="button" class="btn btn-primary" (click)="activeModal.close()">
        @if (isInviteRegistration()) {
          Get Started
        } @else {
          Start working
        }
      </button>
    </div>
  </ng-container>
</component-modal>
